import { render, staticRenderFns } from "./FooterPageView.vue?vue&type=template&id=29aa04da&scoped=true&"
import script from "./FooterPageView.vue?vue&type=script&lang=js&"
export * from "./FooterPageView.vue?vue&type=script&lang=js&"
import style0 from "./FooterPageView.vue?vue&type=style&index=0&id=29aa04da&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29aa04da",
  null
  
)

export default component.exports